import { DisableBlock } from 'common/common-styles'
import clsx from 'clsx'
import {
  CardButton,
  Content,
  DismissButton,
  Icon,
  Subtitle,
  Title,
  Wrapper
} from './styles'

interface Props {
  title: string
  label: string
  iconSrc?: string
  loading?: boolean
  onClick?: () => void
  onDismiss?: () => void
  isDismissing?: boolean
}

const FeedbackCard = ({
  title,
  label,
  iconSrc,
  loading = false,
  onClick,
  onDismiss,
  isDismissing = false
}: Props) => {
  if (loading) {
    return <DisableBlock height={54} width={320} />
  }

  return (
    <CardButton
      className={clsx({
        'is-dismissing': isDismissing
      })}
      onClick={onClick}
    >
      <DismissButton
        className='feedback-dismiss-button'
        type='button'
        aria-label='Dismiss notification'
        onClick={(event) => {
          event.stopPropagation()
          onDismiss?.()
        }}
        disabled={isDismissing}
      >
        X
      </DismissButton>
      <Wrapper>
        {iconSrc && <Icon src={iconSrc} alt={'Notification icon'} />}
        <Content>
          <Title>{title}</Title>
          <Subtitle>{label}</Subtitle>
        </Content>
      </Wrapper>
    </CardButton>
  )
}

export default FeedbackCard
